(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1686],{

/***/ 83719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91164);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56727);
/* harmony import */ var components_atoms_ButtonNew__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30852);
/* harmony import */ var _Icon_fi_FiChevronDown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49604);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["data", "children", "activeIndex", "labelValue", "buttonExtendedClass"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var Dropdown = function Dropdown(_ref) {
  var data = _ref.data,
      _children = _ref.children,
      activeIndex = _ref.activeIndex,
      labelValue = _ref.labelValue,
      buttonExtendedClass = _ref.buttonExtendedClass,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Listbox */ .Ri, _objectSpread(_objectSpread({}, props), {}, {
    as: "div",
    className: props.className ? props.className : " dropdown-default",
    onChange: props.onChange ? props.onChange : function () {},
    children: function children(_ref2) {
      var open = _ref2.open;
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Listbox.Button */ .Ri.Button, {
          className: "relative w-full select-none pl-4  pr-9 text-left font-medium leading-6 h-full".concat(buttonExtendedClass ? " ".concat(buttonExtendedClass) : ""),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            className: open ? "text-bbc-brand-700" : "text-bbc-brand-800",
            children: labelValue && labelValue !== "" ? labelValue : activeIndex
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Icon_fi_FiChevronDown__WEBPACK_IMPORTED_MODULE_2__/* .FiChevronDown */ .b, {
            className: "absolute right-4 top-1/2 float-right -translate-y-1/2 transform align-middle text-bbc-brand-500  ".concat(open ? "rotate-180" : "rotate-0", " transition-all duration-200"),
            size: 20
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Transition */ .uT, {
          leave: "transition-all duration-200 ease-out",
          leaveFrom: "transform  opacity-50",
          leaveTo: "transform  opacity-0",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Listbox.Options */ .Ri.Options, {
            className: "absolute z-10 mt-1 w-full select-none ".concat(props.optionsClass),
            style: props.optionsStyle,
            as: "div",
            children: _children ? _children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
              className: " rounded-b-xl  bg-white pb-2",
              children: Array.isArray(data) && data.map(function (item, index) {
                if (item.title != activeIndex) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Listbox.Option */ .Ri.Option, {
                    value: item.uri,
                    as: "div",
                    className: "block cursor-pointer",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_ButtonNew__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                      as: "a",
                      variant: "ghost",
                      href: item.uri,
                      useRouter: true,
                      btnDisplay: "block",
                      btnTextColor: "text-bbc-brand-700 hover:text-bbc-brand-500",
                      btnPadding: "px-4 py-2",
                      btnTextWeight: "font-normal",
                      children: item.title
                    })
                  }, index);
                }

                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {});
              })
            })
          })
        })]
      });
    }
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (Dropdown);
Dropdown.defaultProps = {
  labelValue: null,
  data: [],
  buttonExtendedClass: null,
  activeIndex: "No thing to choose"
};
/** ========== */

/***/ }),

/***/ 79527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ organisms_SupportedCountries; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./components/atoms/Dropdown/index.js
var Dropdown = __webpack_require__(83719);
// EXTERNAL MODULE: ./components/atoms/Icon/iconBase.js + 1 modules
var iconBase = __webpack_require__(98851);
;// CONCATENATED MODULE: ./components/atoms/Icon/fi/FiExternalLink.js

function FiExternalLink(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "15 3 21 3 21 9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "14",
        "x2": "21",
        "y2": "3"
      }
    }]
  })(props);
}
;
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/LinkRouter/index.js
var LinkRouter = __webpack_require__(27597);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/organisms/SupportedCountries/index.js







/** ========== */





var SupportedCountries = function SupportedCountries(_ref) {
  var data = _ref.data,
      title = _ref.title,
      description = _ref.description,
      descriptionBottom = _ref.descriptionBottom,
      id = _ref.id;

  var _useState = (0,react.useState)(data[0]),
      location = _useState[0],
      setLocation = _useState[1];

  var largestObjLength = data.reduce(function (a, b) {
    return a.listCountries.length > b.listCountries.length ? a : b;
  }).listCountries.length;
  var minHeight = 88 + largestObjLength * 36;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      id: id,
      className: " py-10 text-white lg:py-20 ",
      style: {
        background: "#011221"
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: " relative mb-6 bg-bottom",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "container relative z-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            className: "mb-6 text-center text-bbc-30px font-semibold lg:text-bbc-40px",
            children: title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-6 text-center lg:mb-10",
            children: description
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "relative z-10 hidden  bg-bottom p-16 bg-blend-color lg:block",
            style: {
              background: "#ffffff1a",
              borderRadius: "20px"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "row",
              children: [data.length > 0 && data.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "col-4 mb-6 ",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "h-full border-b pb-6",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                      as: "h3",
                      text: item.label,
                      className: "text-lg font-semibold"
                    })
                  })
                }, index);
              }), data.length > 0 && data.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "col-4",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    children: item.listCountries.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      className: "text-lg",
                      children: item.listCountries.map(function (element, i) {
                        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                          className: "".concat(i > 0 ? "mt-2" : ""),
                          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkRouter/* default */.Z, {
                            href: element.uri,
                            className: "group text-bbc-secondary-300  transition-colors duration-100 hover:text-bbc-yellow-500",
                            children: [element.text, /*#__PURE__*/(0,jsx_runtime.jsx)(FiExternalLink, {
                              size: 16,
                              className: "relative -left-4 ml-2 inline-block opacity-0 transition-all  duration-200 group-hover:left-0 group-hover:opacity-100 "
                            })]
                          })
                        }, i);
                      })
                    })
                  })
                }, index);
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "lg:hidden",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "relative  px-3 py-4 bg-blend-color  ",
              style: {
                minHeight: minHeight,
                background: "#ffffff1a",
                borderRadius: "20px"
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                className: "relative h-full w-auto text-bbc-brand-700",
                buttonExtendedClass: "font-semibold text-lg leading-7 py-2.5 rounded-[14px] bg-white",
                labelValue: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "truncate text-bbc-yellow-500",
                  children: location.label
                }),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "overflow-hidden rounded-xl shadow-md",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "max-h-40 overflow-auto bg-white text-lg",
                    children: data.map(function (item, itemIdx) {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Option */.Ri.Option, {
                        className: "list-none",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: "flex cursor-pointer items-center gap-x-1 px-4 py-2 ".concat(location.value === item.value ? "bg-bbc-primary text-white" : "hover:bg-bbc-primary hover:bg-opacity-40"),
                          onClick: function onClick() {
                            return setLocation(item);
                          },
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "truncate",
                            children: item.label
                          })
                        })
                      }, itemIdx);
                    })
                  })
                })
              }), (location === null || location === void 0 ? void 0 : location.listCountries.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                className: "mt-4",
                children: location.listCountries.map(function (element, i) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "".concat(i > 0 ? "mt-2" : "", " text-lg font-medium"),
                    style: {
                      opacity: "0.9"
                    },
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkRouter/* default */.Z, {
                      href: element.uri,
                      className: "group text-bbc-secondary-300  transition-colors duration-100 hover:text-bbc-yellow-500",
                      children: [element.text, /*#__PURE__*/(0,jsx_runtime.jsx)(FiExternalLink, {
                        size: 16,
                        className: "relative -left-4 ml-2 inline-block opacity-0 transition-all  duration-200 group-hover:left-0 group-hover:opacity-100 "
                      })]
                    })
                  }, i);
                })
              })]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: "/assets/images/common/map-supported-mobile.png",
          width: 375,
          height: 446,
          className: "absolute left-0 right-0 bottom-0 -z-0 ml-auto mr-auto lg:hidden",
          alt: "bg"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: "/assets/images/common/map-supported.png",
          width: 955,
          height: 521,
          className: "absolute left-0 right-0 -bottom-3 -z-0 ml-auto mr-auto hidden lg:block ",
          alt: "bg"
        })]
      }), descriptionBottom]
    })
  });
};

/* harmony default export */ var organisms_SupportedCountries = (SupportedCountries);
SupportedCountries.defaultProps = {
  data: []
};
/** ========== */

/***/ }),

/***/ 40340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./common/data/trustpilot/data.json
var trustpilot_data = __webpack_require__(54356);
// EXTERNAL MODULE: ./common/hooks/useResizeScreenModified.js
var useResizeScreenModified = __webpack_require__(77450);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/LinkRouter/index.js
var LinkRouter = __webpack_require__(27597);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/FormNewsletter/index.js
var FormNewsletter = __webpack_require__(32314);
// EXTERNAL MODULE: ./components/organisms/AboutUs/index.js
var AboutUs = __webpack_require__(63353);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/IndustryNewsInsights/index.js
var IndustryNewsInsights = __webpack_require__(93008);
// EXTERNAL MODULE: ./components/organisms/OurPartners/index.js + 3 modules
var OurPartners = __webpack_require__(90895);
// EXTERNAL MODULE: ./components/organisms/SupportedCountries/index.js + 1 modules
var SupportedCountries = __webpack_require__(79527);
// EXTERNAL MODULE: ./components/organisms/TrustpilotFeedBack/index.js + 1 modules
var TrustpilotFeedBack = __webpack_require__(91630);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/offshore/index.js




/* Components */





 // Import BannerChristmas from "components/organisms/BannerChristmas";









var Component = function Component(_ref) {
  var posts = _ref.posts,
      countries = _ref.countries,
      data = _ref.data;

  var _useState = (0,react.useState)("DESKTOP"),
      screen = _useState[0],
      setScreen = _useState[1];

  (0,useResizeScreenModified/* default */.Z)(setScreen);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
        minHeightBanner: "banner-min-h-600",
        title: "Helping you see real growth",
        description: "We cover all grounds where you as startups, small business owners, CSPs are contemplating for. Global digital incorporation with ease, tech-enabled corporate services for efficient management. Get started to grow your business!",
        bgStyle: {
          backgroundBlendMode: "normal, overlay, normal, normal, normal"
        },
        bgColor: "bg-bbc-gradient-10 bg-[length:180%_180%] animate-[gradientAnimation_10s_ease_infinite]",
        isApplyCompanyForm: countries,
        leftClassName: "relative mt-4 lg:mt-0 col-12 lg:col-6 xl:col-7 z-40  ",
        rightClassName: "static hidden lg:block lg:col-6 xl:col-5 ",
        wave: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "relative",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
            src: "/assets/images/wave/exclude-wave.svg",
            className: "h-full w-full",
            width: 1920,
            height: 95,
            wrapper: {
              className: "w-full h-full"
            },
            alt: "banner-img"
          })
        }),
        rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: screen === "DESKTOP" && /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
            className: "w-full ",
            wrapper: {
              className: "bbc-banner-image-bottom-0 banner-home"
            },
            src: "/assets/images/offshore/home/banner-offshore-home.png",
            width: 1034,
            height: 720,
            alt: "tech-enabled offshore company registration service",
            priority: true
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(IndustryNewsInsights/* default */.Z, {
      data: posts
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AboutUs/* default */.Z, {
      data: data === null || data === void 0 ? void 0 : data.dataAboutUs
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OurPartners/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: "relative mb-0 pt-10 pb-6 lg:bg-bbc-brand-100 lg:pt-28 lg:pb-32",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        className: "absolute left-0 right-0 w-full",
        style: {
          top: "-4px"
        },
        src: "/assets/images/wave/curve_home-wave.svg",
        width: 1920,
        height: 158,
        wrapper: {
          className: "hidden lg:block"
        },
        alt: "wave3"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          text: "Our Services",
          className: "mb-6 text-bbc-30px font-semibold text-bbc-brand-800 lg:text-bbc-40px"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "leading-bbc-26 text-bbc-gray",
          children: "We cover a wide range of digital corporate services to help your business get things done right from the start, and other supporting areas that keep it running smoothly during company operation."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row mt-6 items-center lg:mt-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-1 hidden lg:block"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 lg:col-5",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                as: "h3",
                text: "Company Formation",
                className: "mb-4 text-2xl font-semibold leading-9 text-bbc-brand-800 lg:mb-6 lg:text-bbc-30px"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "mb-6 leading-bbc-26",
                children: "We offer tech-based solutions of choice for your company formation in over 18 markets spanned across continents. With a full range of supporting corporate services, we can help you easily establish and manage your company during your operation."
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "text-center lg:text-left",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                  href: "/company-formation",
                  className: "inline-block cursor-pointer rounded-[50px] border border-bbc-brand-500 py-2 px-6 font-semibold leading-bbc-26 text-bbc-brand-500 hover:bg-bbc-brand-500 hover:text-white",
                  children: "Explore"
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 mt-6 text-center lg:col-6 lg:mt-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/offshore/home/company_formation-home-offshore.png",
              width: 540,
              height: 540,
              alt: "company-formation"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row mt-6 items-center lg:mt-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 order-2 mt-6 text-center lg:col-6 lg:order-0 lg:mt-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/offshore/home/bank_account-offshore-home.png",
              width: 540,
              height: 540,
              alt: "bank-account"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 lg:col-5",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                as: "h3",
                text: "Bank Account Opening",
                className: "mb-4 text-2xl font-semibold leading-9 text-bbc-brand-800 lg:mb-6 lg:text-bbc-30px"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "mb-6 leading-bbc-26",
                children: "We offer bank account introduction in offshore jurisdictions as well as financial hubs in Asia where your money can be safe and ready for global trading without currency control. A wide banking network and a healthy long-term relationship with international and offshore banks allow us to better serve customers with various objectives."
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "text-center lg:text-left",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                  href: "/banking-support",
                  className: "inline-block cursor-pointer rounded-[50px] border border-bbc-brand-500 py-2 px-6 font-semibold leading-bbc-26 text-bbc-brand-500 hover:bg-bbc-brand-500 hover:text-white",
                  children: "Explore"
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-1 hidden lg:block"
          })]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: "relative mb-0 pb-10 lg:pt-0 lg:pb-20",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        className: "w-full",
        src: "/assets/images/wave/curve_home1-wave.svg.svg",
        width: 1920,
        height: 116,
        wrapper: {
          className: "hidden lg:block"
        },
        alt: "wave4"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "lg:-mt-52",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "container",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "row items-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "col-1 hidden lg:block"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "col-12 lg:col-5",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                  as: "h3",
                  text: "Accounting & Auditing",
                  className: "mb-4 text-2xl font-semibold leading-9 text-bbc-brand-800 lg:mb-6 lg:text-bbc-30px"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "mb-6 leading-bbc-26",
                  children: "We're interested in keeping your resources low and your numbers high. Get back precious time and resources for your business with our cost-effective accounting and regulatory compliance services."
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "text-center lg:text-left",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                    href: "/accounting-and-auditing",
                    className: "inline-block cursor-pointer rounded-[50px] border border-bbc-brand-500 py-2 px-6 font-semibold leading-bbc-26 text-bbc-brand-500 hover:bg-bbc-brand-500 hover:text-white",
                    children: "Explore"
                  })
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "col-12 mt-6 text-center lg:col-6 lg:mt-0",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                src: "/assets/images/common/accounting_auditing-offshore_vn.png",
                width: 540,
                height: 541,
                alt: "accounting-auditing"
              })
            })]
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SupportedCountries/* default */.Z, {
      title: "Our Worldwide Supported Countries",
      description: "Set up your business in over +15 countries and receive consultations from our local experts.",
      data: data.supportedCountries
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "title-h2 mb-6 pb-0 text-center text-bbc-brand-800",
          children: "Testimonials"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: "text-center",
          children: ["Clients talked about us on", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "font-medium text-bbc-primary hover:text-bbc-secondary-300",
            target: "_blank",
            rel: "noreferrer",
            href: "https://www.trustpilot.com/review/bbcincorp.com",
            children: "Trustpilot"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrustpilotFeedBack/* default */.Z, {
          data: trustpilot_data/* feedback */.I
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormNewsletter/* default */.Z, {})]
  });
};

/* harmony default export */ var offshore = (Component);
Component.defaultProps = {
  data: {},
  posts: []
};
;// CONCATENATED MODULE: ./pages/offshore/data.json
var offshore_data_namespaceObject = JSON.parse('{"dataAboutUs":{"title":"About Us","description":"<p class=\\"mb-4\\"><a href=\\"offshore/about-us\\"><span class=\\"text-bbc-secondary-300\\">BBCIncorp Limited</span></a> was established in 2017 with a mission to help startups and SMEs to free their resources tied up to intimidating company administration tasks, and thus speed up the process of setting up and running a business, unleash their potential power for growth and expansion.</p><p>Our services are specialized in company formation, banking assistance, accounting & auditing, legal administration and much more in 20 countries across the globe. Our proven IT strategy with usage of technology advancement along with long-term sustainable relationships in the industry allow us to deliver services at scale with minimum costs. Wherever you want to initialize your business, BBCIncorp can help to accelerate the process in a reliable and successful manner.</p>"},"supportedCountries":[{"label":"The Americas","value":"the-americas","listCountries":[{"text":"Anguilla","uri":"/company-formation/anguilla"},{"text":"Bahamas","uri":"/company-formation/bahamas"},{"text":"Belize","uri":"/company-formation/belize"},{"text":"British Virgin Islands","uri":"/company-formation/bvi"},{"text":"Cayman Islands","uri":"/company-formation/cayman-islands"},{"text":"Delaware (US)","uri":"/company-formation/delaware"},{"text":"Panama","uri":"/company-formation/panama"},{"text":"St. Kitts & Nevis","uri":"/company-formation/saint-kitts-and-nevis"},{"text":"St. Vincent & Grenadines","uri":"/company-formation/saint-vincent-and-grenadines"}]},{"label":"Europe, Middle East and Africa (EMEA)","value":"emea","listCountries":[{"text":"Cyprus","uri":"/company-formation/cyprus"},{"text":"Mauritius","uri":"/company-formation/mauritius"},{"text":"Seychelles","uri":"/company-formation/seychelles"},{"text":"Ras AI Khaimah (UAE)","uri":"/company-formation/rak"},{"text":"United Kingdom","uri":"/company-formation/united-kingdom"}]},{"label":"Asia Pacific","value":"asia-pacific","listCountries":[{"text":"Marshall Islands","uri":"/company-formation/marshall-islands"},{"text":"Samoa","uri":"/company-formation/samoa"}]}]}');
;// CONCATENATED MODULE: ./pages/offshore/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    locationRouter: "offshore",
    page: data === null || data === void 0 ? void 0 : data.page,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(offshore, {
      countries: data === null || data === void 0 ? void 0 : data.countries,
      posts: data === null || data === void 0 ? void 0 : data.posts,
      data: offshore_data_namespaceObject
    })
  });
}

/***/ }),

/***/ 41009:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore",
      function () {
        return __webpack_require__(40340);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,9885,8352,8528,4090,9738,7447,2314,5111,2888,179], function() { return __webpack_exec__(41009); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);